import React from 'react';
import usePagination from '@material-ui/lab/Pagination/usePagination';
import { makeStyles } from '@material-ui/core/styles';
import { styled } from '@material-ui/core/styles';
import { theme } from 'theme';
import { SdmTextButton, SdmTypography } from './';
import { ArrowBack, ArrowForward } from '@material-ui/icons';

const useStyles = makeStyles({
  ul: {
    listStyle: 'none',
    padding: 0,
    margin: 0,
    display: 'flex',
  },
});
const HoveredTypo = styled(SdmTypography)({
  '&:hover > div': {
    color: `${theme.colors.primary.red} !important`,
    cursor: 'pointer',
  },
});

export const SdmPaginator = ({
  callBackFunction,
  totalPages,
  i18n,
  isSmDown,
  isXsDown,
}) => {
  const classes = useStyles();
  const { items } = usePagination({
    count: totalPages,
  });

  const handleClick = ({ e, onClick, page, type, selected }) => {
    onClick(e);
    if (!selected) {
      callBackFunction && callBackFunction({ page, type });
    }
  };

  return (
    <nav>
      <ul className={classes.ul}>
        {items.map(({ page, type, selected, onClick, ...item }, index) => {
          let children = null;

          if (type === 'start-ellipsis' || type === 'end-ellipsis') {
            children = !isXsDown ? (
              <SdmTypography variant={'text'} style={{ paddingTop: 20 }}>
                …
              </SdmTypography>
            ) : null;
          } else if (type === 'page') {
            children = !isXsDown ? (
              <HoveredTypo
                variant={
                  selected
                    ? isSmDown
                      ? 'h5'
                      : 'h2'
                    : isSmDown
                    ? 'h5Regular'
                    : 'h2Regular'
                }
                onClick={(e) =>
                  handleClick({ e, onClick, page, type, selected })
                }
                style={{
                  color: selected
                    ? `${theme.colors.primary.red}`
                    : `${theme.colors.primary.black}`,
                  paddingTop: selected
                    ? isSmDown
                      ? 19
                      : 12
                    : isSmDown
                    ? 20
                    : 13,
                }}
                {...item}
              >
                {page}
              </HoveredTypo>
            ) : null;
          } else {
            children = (
              <SdmTextButton
                variant="noneInverted"
                text={i18n.buttons[`${type}`]}
                textVariant={isSmDown ? 'h5Regular' : 'h2Regular'}
                positionArrow={type === 'next' ? 'right' : 'left'}
                onClick={(e) =>
                  handleClick({ e, onClick, page, type, selected })
                }
                {...item}
              >
                {type === 'next' ? <ArrowForward /> : <ArrowBack />}
              </SdmTextButton>
            );
          }

          return <li key={index}>{children}</li>;
        })}
      </ul>
    </nav>
  );
};
